import { Link } from 'react-router-dom'

const MovieCard = ({ movie }) => {
	const posterUrl = `https://image.tmdb.org/t/p/w500/${movie.poster_path}`
	const detailUrl = `/movies/${movie.id}`

	return (
		<div className='col-lg-3 col-md-4 col-6 my-4'>
			<div className='card p-1 '>
				<Link to={detailUrl}>
					<img
						src={posterUrl}
						className='card-img-top'
						alt={movie.original_title}
					/>
				</Link>
				<div className='card-body'>
					<h5 className='card-title'>{movie.original_title}</h5>
				</div>
			</div>
		</div>
	)
}

export default MovieCard
